import script from "./TurbomedicsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TurbomedicsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__